import { TemplateRef } from '@angular/core';
import { COLUMN_IDENTIFIERS } from '../../../pages/employee-flow/const';

/**
 * UI_Version_2: the SLA and remaining time columns become one SLA column.
 * It keeps the SLA column's place, header and sort key; the remaining time column is dropped.
 */
export function mergeSlaSummaryColumns<T extends { identifier?: string }>(
  columns: T[],
  enabled: boolean
): T[] {
  if (!enabled) {
    return columns;
  }
  return columns.filter(
    column => column.identifier !== COLUMN_IDENTIFIERS.REMAINING_TIME
  );
}

/** The cell templates matching mergeSlaSummaryColumns, in the same order. */
export function mergeSlaSummaryTemplates<
  T extends { identifier?: string; template: TemplateRef<unknown> },
>(
  templates: T[],
  enabled: boolean,
  summaryTemplate: TemplateRef<unknown>
): T[] {
  if (!enabled) {
    return templates;
  }
  return templates
    .filter(item => item.identifier !== COLUMN_IDENTIFIERS.REMAINING_TIME)
    .map(item =>
      item.identifier === COLUMN_IDENTIFIERS.SLA
        ? { ...item, template: summaryTemplate }
        : item
    );
}
